import axios from 'axios'
import notifService from '../../services/notifService'

export const getActivity = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/activities', {
      params: pagination
    })
    .then(response => {
      commit('getActivity', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const activityExcel = async (_context, pagination) => {
  let res = await axios
    .get('/cms/activities/report/excel', {
      params: pagination,
      responseType: 'blob'
    })
    .then(response => {
      let date_start = pagination.start_date ? '_' + pagination.start_date : ''
      let date_end = pagination.end_date ? '_' + pagination.end_date : ''

      let fileTitle = 'Activity_Report' + date_start + date_end + '.xlsx'

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileTitle)
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getActivityDetail = async ({ commit }, val) => {
  return await axios
    .get('/cms/activities/detail/' + val)
    .then(response => {
      commit('getActivityDetail', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const editActivity = async (_context, val) => {
  return await axios
    .put('/cms/activities/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const deleteActivity = async (_context, val) => {
  return await axios
    .delete('/cms/activities/delete/' + val.id)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const getCustomerHaveSales = async ({ commit }, val) => {
  await axios
    .get('/cms/activities/customer-have-sales/' + val)
    .then(response => {
      commit('getCustomerHaveSales', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const getSalesHaveCustomer = async ({ commit }, val) => {
  await axios
    .get('/cms/activities/sales-have-customer/' + val)
    .then(response => {
      commit('getSalesHaveCustomer', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

// daily activity
export const getActivityDaily = async ({ commit }, pagination) => {
  return await axios
    .get('/cms/activities/daily', {
      params: pagination
    })
    .then(response => {
      commit('getActivityDaily', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const addActivityDaily = async (_context, val) => {
  let res = await axios
    .post('/cms/activities/daily', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const editActivityDaily = async (_context, val) => {
  return await axios
    .put('/cms/activities/daily/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deleteActivityDaily = async (_context, val) => {
  return await axios
    .delete('/cms/activities/daily/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const dailyActivityForm = (context, val) => {
  context.commit('dailyActivityForm', val)
}

// daily activity type
export const getDailyType = async (context, pagination) => {
  let res = await axios
    .get('/cms/activities/daily/type', {
      params: pagination
    })
    .then(response => {
      context.commit('getDailyType', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addDailyType = async (_context, val) => {
  return await axios
    .post('/cms/activities/daily/type', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const editDailyType = async (_context, val) => {
  return await axios
    .put('/cms/activities/daily/type/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deleteDailyType = async (_context, val) => {
  return await axios
    .delete('/cms/activities/daily/type/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const listDailyActivityType = async context => {
  await axios
    .get('/cms/activities/daily/type', {
      params: {
        per_page: 100
      }
    })
    .then(response => {
      context.commit('listDailyActivityType', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const dailyTypeForm = (context, val) => {
  context.commit('dailyTypeForm', val)
}

export const dailyTableSort = (context, val) => {
  context.commit('dailyTableSort', val)
}

export const activityTableSort = (context, val) => {
  context.commit('activityTableSort', val)
}

// actions
export const getActivityAction = async (context, pagination) => {
  let res = await axios
    .get('/cms/activities/action', {
      params: {
        filter: pagination.filter,
        page: pagination.current_page
      }
    })
    .then(response => {
      context.commit('getActivityAction', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addActivityAction = async (_context, val) => {
  let res = await axios
    .post('/cms/activities/action', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const editActivityAction = async (_context, val) => {
  let res = await axios
    .put('/cms/activities/action/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const deleteActivityAction = async (_context, val) => {
  console.log(val)
  let res = await axios
    .delete('/cms/activities/action/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const activityActionForm = (context, val) => {
  context.commit('activityActionForm', val)
}

export const activityActionFormReset = context => {
  context.commit('activityActionFormReset')
}

export const todayActivity = async (context, val) => {
  let res = await axios
    .get('/cms/activities/today', {
      params: val
    })
    .then(response => {
      let data = response.data.data
      context.commit('todayTable', data.tables)
      context.commit('todayMap', data.maps)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

// export const todayMap = async (context) => {
//   await axios
//     .get('/cms/activities/today/maps')
//     .then(response => {
//       context.commit('todayMap', response.data.data)
//     })
//     .catch(error => {
//       if (error.response) {
//         notifService.notif('apiRes', error.response.data.message, 'error')
//       }
//     })
// }

export const getWeekly = async context => {
  return await axios
    .get('/cms/activities/weekly')
    .then(response => {
      context.commit('getWeekly', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const getSalesActivity = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/sales-activity', {
      params: pagination
    })
    .then(response => {
      commit('getSalesActivity', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const detailSalesActivity = ({ commit }, data) => {
  commit('detailSalesActivity', data)
}

export const putSalesActivity = async (_context, data) => {
  let res = await axios
    .put('/cms/sales-activity/' + data.id, data)
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const setFinalize = async (_context, val) => {
  let res = await axios
    .post('/cms/activities/finalization', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}
